import { Outlet } from 'react-router';
import type { User } from '@cleartask/shared';
import { Sidebar } from './Sidebar.js';
import { SyncIndicator } from './SyncIndicator.js';
import { TabBar } from './TabBar.js';

interface AppShellProps {
  user: User;
}

/**
 * Layout base: sidebar no desktop, tab bar no mobile (spec 8).
 * O padding inferior no mobile reserva a altura da tab bar para que o ultimo
 * item de uma lista nao fique embaixo dela.
 */
export function AppShell({ user }: AppShellProps) {
  return (
    <div className="flex min-h-dvh">
      <Sidebar user={user} />
      <main className="flex-1 pb-tabbar md:pb-0">
        {/*
          O indicador vive no shell, e nao em cada tela: perder a rede vale para
          o app inteiro, e repeti-lo por tela criaria cinco lugares para o mesmo
          estado divergir. Ele nao renderiza nada quando nao ha o que dizer.
        */}
        <div className="sticky top-0 z-20 flex justify-center px-4 pt-2 empty:hidden">
          <SyncIndicator />
        </div>

        <Outlet />
      </main>
      <TabBar />
    </div>
  );
}
